import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { selectSearchText } from "../../../store/documentsSignerList/selectors/selectSearchText";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";
import { setSearchText } from "../../../store/documentsSignerList";

export const SearchTextInput: React.FC = () => {
  const dispatch = useDispatch();
  const value = useSelector(selectSearchText);
  return (
    <IonSearchbar
      value={value}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
        dispatch(fetchDocuments());
      }}
      debounce={700}
      placeholder={"Buscar acuerdo"}
    />
  );
};
